import { cx } from 'cvb';
import _ from 'lodash';
import PropTypes from 'prop-types';
import constants from '../../../config/constants';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import { getMetaKey } from '../../Availability/common';
import { DeliveryMethodSelectorStyles } from './DeliveryMethodSelector.styles';

const DeliveryMethodSelector = ({
  availabilityList,
  isMapView,
  type,
  setSelectedType,
  appCtx,
  setView,
  deliveryActions,
}) => {
  const { siteConfig } = appCtx;
  const { AVAILABILITY_ICON_CLASS_MAPPER } = constants;
  const {
    HOME_DELI_SELECTOR_TITLE = 'Envio',
    PICKUP_INSTORE_SELECTOR_TITLE = 'Retiro',
    STOCK_IN_STORE_SELECTOR_TITLE = 'En tienda',
  } = _.get(siteConfig, 'textDictionary', {});

  const selectorTitles = {
    HOME_DELI_SELECTOR_TITLE,
    PICKUP_INSTORE_SELECTOR_TITLE,
    STOCK_IN_STORE_SELECTOR_TITLE,
  };

  const { handleSetEntry } = deliveryActions;

  const handleSelect = (key) => {
    if (setSelectedType && typeof setSelectedType === 'function') {
      setSelectedType(key);
      handleSetEntry(key);
      setView('map');
    }
  };

  return (
    <>
      <div className={cx('selectorWrapper', isMapView && 'map-view')}>
        {availabilityList.map(({ shippingOptionType }) => {
          const { labelsKey } = getMetaKey(shippingOptionType);
          const { selectorTitle } = labelsKey;
          return (
            <button
              type="button"
              key={shippingOptionType}
              className={`option ${type === shippingOptionType ? 'selected' : ''}`}
              onClick={() => handleSelect(shippingOptionType)}
            >
              <div className={`icon ${AVAILABILITY_ICON_CLASS_MAPPER[shippingOptionType]}`} />
              <span>{selectorTitles[selectorTitle]}</span>
            </button>
          );
        })}
      </div>
      <style jsx>{DeliveryMethodSelectorStyles}</style>
    </>
  );
};

DeliveryMethodSelector.propTypes = {
  availabilityList: PropTypes.array,
  isMapView: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  setSelectedType: PropTypes.func,
  appCtx: PropTypes.object.isRequired,
  setView: PropTypes.func.isRequired,
  deliveryActions: PropTypes.object.isRequired,
};
DeliveryMethodSelector.defaultProps = {
  availabilityList: [],
  setSelectedType: null,
};

export default withApplicationContext(DeliveryMethodSelector);
